export default __webpack_public_path__ + "static/media/success_icon.39605d5d.svg";